import { RestAuthUser, SpotifyAccessToken } from '@/types'
import axios from 'axios'
import host from '../../utils/host'

class AuthRest {
  private host: string = host

  public loginUrl (campaignId: number): string {
    return `${this.host}/api/auth/spotify/user_token?redirect_uri=${encodeURIComponent(window.location.href)}&campaign_id=${campaignId}`
  }

  public get (token: string): Promise<RestAuthUser> {
    return axios.get(`${this.host}/api/users/me`, {
      headers: {
        Authorization: token
      }
    }).then((res) => res.data)
  }

  // Fresh Spotify access token for the logged-in user's own account. Used as
  // the refresh path when the one piggybacked on `get()` is near expiry.
  public getSpotifyToken (token: string): Promise<SpotifyAccessToken> {
    return axios.get(`${this.host}/api/users/me/spotify-token`, {
      headers: {
        Authorization: token
      }
    }).then((res) => res.data)
  }
}

export default new AuthRest()
